var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"Options"},_vm._l((_vm.options),function(option){return _c('li',{key:option.id,staticClass:"Options__Option",on:{"click":function($event){return _vm.selectOption(option.id)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }